"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = __importStar(require("react"));
var react_2 = require("@emotion/react");
var rc_tooltip_1 = __importDefault(require("rc-tooltip"));
var styles_1 = require("./styles");
var Tooltip = react_1.forwardRef(function (props, ref) {
    var theme = react_2.useTheme();
    var style = react_1.useMemo(function () { return styles_1.getTooltipStyle(theme); }, [theme]);
    // when there is no overlay nothin happens - what is ternary condition supposed
    // to do / what is the expected behavior
    return props.overlay ? (react_2.jsx(react_1.default.Fragment, null,
        react_2.jsx(react_2.Global, { styles: style }),
        react_2.jsx(rc_tooltip_1.default, __assign({}, props, { ref: ref, overlayStyle: __assign({ width: 'max-content', maxWidth: '500px' }, props.overlayStyle) })))) : (props.children || null);
});
var WrappedTooltip = react_1.forwardRef(function (props, ref) {
    var containerRef = react_1.useRef(null);
    return (react_2.jsx(Tooltip, __assign({}, props, { ref: ref, getTooltipContainer: function () { return containerRef.current || document.body; } }),
        react_2.jsx("span", { style: { position: 'relative' }, ref: containerRef }, props.children)));
});
exports.default = Object.assign(Tooltip, { Wrapped: WrappedTooltip });
